export const FallbackErrorScreen = () => (
  <div
    style={{
      backgroundColor: '#fdfcfc',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      padding: '2rem',
    }}
  >
    <div
      style={{
        backgroundColor: '#fff0f3',
        border: '1px solid #ffa3a3',
        borderRadius: '12px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
        padding: '2rem 3rem',
        maxWidth: '420px',
        textAlign: 'center',
      }}
    >
      <h1
        style={{
          color: '#c92a2a',
          fontSize: '1.5rem',
          marginBottom: '0.75rem',
        }}
      >
        Encontramos un problema
      </h1>
      <p style={{ marginBottom: '0.5rem', color: '#5c1a1a' }}>Este error ya fue registrado por nuestro equipo.</p>
      <p style={{ color: '#5c1a1a' }}>
        Puedes intentar recargar la página. Si el problema persiste, lo resolveremos lo antes posible.
      </p>
      <p style={{ color: '#5c1a1a', fontStyle: 'italic', marginTop: '1rem' }}>Gracias por tu comprensión.</p>
      <pre
        style={{
          fontSize: '0.75rem',
          marginTop: '1.5rem',
          color: '#999',
          background: '#fff',
          padding: '0.5rem',
          borderRadius: '4px',
        }}
      >
        <code>{__APP_VERSION__}</code>
      </pre>
    </div>
  </div>
)
